import { render, staticRenderFns } from "./AIModelLayerList.vue?vue&type=template&id=15c65b62&"
import script from "./ai-model-layer-list.js?vue&type=script&lang=js&"
export * from "./ai-model-layer-list.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports